import type { Config } from './types'


const config: Config = __CLIENT__ ? require('./client').default : require('./server').default


export default config
